import React from 'react';
import { FileSearch, Scale, TrendingUp } from 'lucide-react';
import { Button } from './ui/Button';
import { useTranslations } from '../hooks/useTranslations';
export function HowItWorks() {
  const {
    t
  } = useTranslations();
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    contactSection?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  const steps = [{
    id: 1,
    icon: <FileSearch className="w-8 h-8 text-white" data-id="element-266" />,
    title: t('howItWorks.step1.title'),
    description: t('howItWorks.step1.desc')
  }, {
    id: 2,
    icon: <Scale className="w-8 h-8 text-white" data-id="element-267" />,
    title: t('howItWorks.step2.title'),
    description: t('howItWorks.step2.desc')
  }, {
    id: 3,
    icon: <TrendingUp className="w-8 h-8 text-white" data-id="element-268" />,
    title: t('howItWorks.step3.title'),
    description: t('howItWorks.step3.desc')
  }];
  return <section id="how-it-works" className="py-20 bg-gray-50" data-id="element-269">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-270">
        <div className="text-center mb-16" data-id="element-271">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-272">
            {t('howItWorks.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-273">
            {t('howItWorks.subtitle')}
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-274">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gradient-to-r from-purple-200 via-purple-300 to-purple-200" data-id="element-275" />

          {steps.map((step, index) => <div key={step.id} className="flex flex-col items-center text-center relative animate-fade-in-up" style={{
          animationDelay: `${index * 0.1}s`
        }} data-id="element-276">
              <div className="w-24 h-24 rounded-full bg-gradient-to-br from-purple-600 to-fuchsia-500 flex items-center justify-center shadow-lg shadow-purple-500/30 mb-6 relative z-10 border-4 border-white" data-id="element-277">
                {step.icon}
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gray-900 text-white flex items-center justify-center font-bold text-sm border-2 border-white" data-id="element-278">
                  {step.id}
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-279">
                {step.title}
              </h3>
              <p className="text-gray-600 max-w-xs" data-id="element-280">{step.description}</p>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-281">
          <Button size="lg" onClick={scrollToContact} data-id="element-282">
            {t('contact.formTitle')}
          </Button>
        </div>
      </div>
    </section>;
}